export const BASE_URL = "https://api.auratechacademy.com";